import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Constants } from '../configs';
import { ApiService } from './api.service';
import { Product } from '../models';
import { DispatchesPromotionRequest } from '../models/sale/dispatches-promotion-request.model';
import { transformAccordingToDecimals } from '../helpers/util';
import { measurableProduct } from '../configs/measurable-product.config';
import { SALE_ENTERPRISE } from '../configs/sale-enterprise.config';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  typeSend = Constants.SaleConfig;
  constructor(private apiService: ApiService) { }

  getProductPromotions(productPromotionsRequest: DispatchesPromotionRequest): Observable<DispatchesPromotionRequest> {
    return this.apiService
      .post(this.apiService.getDiscountsByProducts, productPromotionsRequest);
  }

  searchProductEanSku(typeSearch, searchSku): Observable<Product[]> {
    return this.apiService
      .get(`${this.apiService.searchProduct}?${typeSearch}=${searchSku}`);
  }

  searchProducts(params: any): Observable<any> {
    return this.apiService.post(this.apiService.searchProduct, params);
  }

  validProducts(params: any): Observable<any> {
    return this.apiService.post(`${this.apiService.searchProduct}/valid`, params);
  }

  searchProductImage(sku: string, store?:string): Observable<any> {
    return this.apiService
    .get(`${this.apiService.searchProduct}/images/${sku}?store=${store}`);
  }

  searchAutocompleteDescription(text: string) {
    return this.apiService.get(`${this.apiService.searchProduct}/search?text=${text}&limit=20`)
      .pipe(map(map => {
        return map.sort((a, b) => {
          if(b.description.toLowerCase().includes(text.toLowerCase())) {
            return 1;
          }
          if(!b.description.toLowerCase().includes(text.toLowerCase())) {
            return -1;
          }
          return 0;
        });
      }));
  }

  /**
   * Evalúa si el sku es un producto (ST: Producto, SV: Servicio, FL: Flete) ST falso
   * @param productType tipo de sku
   */
  productTypeSale(productType) {
    return productType === this.typeSend.productType.ST;
  }

  quantityRoundDecimal(item, quantity): number {
    let parseQuantity = 0;
    if (item.measurable === measurableProduct.isMeasurable && item.conversionFactor) {
      const numberOfDecimals = item.conversionFactor.toString().length - 1;
      parseQuantity = transformAccordingToDecimals(Number(quantity), numberOfDecimals);
    } else {
      parseQuantity = parseInt(quantity, 10);
    }
    return Number(parseQuantity);
  }

  roundDecimalInSaleEnterprise(item, quantity): number {
    let parseQuantity = 0;
    if (item.measurable === measurableProduct.isMeasurable && item.conversionFactor) {
      const numberOfDecimals = SALE_ENTERPRISE.numOfDecimals
      ? SALE_ENTERPRISE.numOfDecimals
      : item.conversionFactor.toString().length - 1;
      parseQuantity = transformAccordingToDecimals(Number(quantity), numberOfDecimals);
    } else {
      parseQuantity = parseInt(quantity, 10);
    }
    return Number(parseQuantity);
  }
}
